import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Offcanvas from 'react-bootstrap/Offcanvas';
import Button from './Button.jsx';
import { hideOffCanvasThree } from '../commonSlice.js';
import PropTypes from "prop-types";
import "./features.common.styles.scss";

const CustomOffCanvasThree = (props) => {
  const dispatch = useDispatch();
  const isOffCanvasOpen = useSelector((state) => state.common?.offcanvasThreeState?.isDrilldownThreeOpen)
  return (
    <Offcanvas
      placement="end"
      className={props.className}
      show={isOffCanvasOpen}
      backdropClassName='drilldownThree_backdrop'
    >
      <Button
        className="btn-close text-reset"
        data-testid="offcanvas-three-close-btn" 
        text="×"
        onClick={() => {
          dispatch(hideOffCanvasThree(false));
          }}
      />
      <div className={`custom_scroll ${props?.classNameOffcanvas || "offcanvasPadding"}`}>
        {props?.children}
      </div>
    </Offcanvas>
  );
};
CustomOffCanvasThree.propTypes = {
  onCancel: PropTypes.bool,
  className: PropTypes.arrayOf(PropTypes.object).isRequired,
  children: PropTypes.arrayOf(PropTypes.object).isRequired,
};
export default CustomOffCanvasThree;



